module.exports = __webpack_public_path__ + "static/media/logo.5406e4b7.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/logo.png
 ** module id = 65
 ** module chunks = 0
 **/